import { Dataset } from '../../types/types';

export const getDetailItemsParamArray = (dataset: Dataset) => {
  const filteredItems = (dataset.items ?? []).filter(
    (item) => item.detailVisible !== false || item.name === dataset.idItem
  );
  const items: string[] = filteredItems.map(({ name }) => name);

  filteredItems.forEach((item) => {
    if (item.formatItem) {
      items.push(item.formatItem);
    }
  });

  return items;
};
